<div class="row" *ngIf="title !== undefined">
  <div *ngIf="!noTitle" class="col-md-4"><label>{{title}}</label></div>
  <div class="col-md-8">
    <div class="form-group">

      <input *ngIf="!multiline"
        type="text"
        [ngClass]="(disabled)?'form-control form-control-sm nrk-disabled-background':'form-control form-control-sm'"
        [ngStyle]="getStyles()"
        [placeholder]="title" [(ngModel)]="value"
        (input)="updateValue($any($event.target).value)"
        (keyup)="onKey($event)"
        (keydown)="onKeydown($event)"
        (focus)="focus.emit($event)"
        (focusout)="focusLost.emit(value)"
        [attr.maxlength]="this.maxChars"
        [attr.disabled]="disabled ? '' : null">
      <div #formfield *ngIf="multiline"
        [ngStyle]="getStyles({ 'min-height': getMinHeight() })"
        [attr.contenteditable]="disabled ? null : ''"
        [ngClass]="(disabled)?'form-control nrk-disabled-background multiline':'form-control multiline'"
        (keyup)="onKey($event)"
        (keydown)="onKeydown($event)"
        (focus)="focus.emit($event)"
        (focusout)="focusLost.emit(value)"
        (paste)="onPaste($event)"
        [attr.disabled]="disabled ? '' : null">
      </div>
    </div>
  </div>
</div>

<div class="form-group" *ngIf="title === undefined">
  <input *ngIf="!multiline"
    type="text"
    [ngClass]="(disabled)?'form-control form-control-sm nrk-disabled-background':'form-control form-control-sm'"
    [ngStyle]="getStyles()"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (input)="updateValue($any($event.target).value)"
    (keyup)="onKey($event)"
    (keydown)="onKeydown($event)"
    (focus)="focus.emit($event)"
    (focusout)="focusLost.emit(value)"
    [attr.maxlength]="this.maxChars"
    [attr.disabled]="disabled ? '' : null">
  <div *ngIf="multiline && placeholder && !value" style="position:relative;height:0;top:6px;left:8px;color:#999;pointer-events:none">{{placeholder}}</div>
  <div #formfield *ngIf="multiline"
    [ngStyle]="getStyles({ 'min-height': getMinHeight() })"
    [attr.contenteditable]="disabled ? null : ''"
    [ngClass]="(disabled)?'form-control nrk-disabled-background multiline':'form-control multiline'"
    (keyup)="onKey($event)"
    (keydown)="onKeydown($event)"
    (focus)="focus.emit($event)"
    (focusout)="focusLost.emit(value)"
    (paste)="onPaste($event)"
    [attr.disabled]="disabled ? '' : null">
  </div>
</div>
